import { Escala } from "@/components/ui/controles";
import { useDatos } from "../store/store";
import { encadenar, setDiagAnsweredAt, setEnLista } from "../store/acciones";
import { SeccionLayout, Bloque } from "../componentes/SeccionLayout";
import { CandadoSensibles } from "../componentes/CandadoSensibles";
import { useFotoEnVivo } from "../useFotoEnVivo";
import { AREAS_RUEDA, fechaCorta, hoyISO, siguienteDiagnostico, TOTAL_RUEDA } from "./preguntas-diagnostico";

/** Diagnóstico de riqueza 360 (pág. 5 del cuaderno): 12 preguntas de 1 a 10, tres áreas. Se repite cada trimestre. */
export function Rueda() {
  const d = useDatos((x) => x.inputs.diag);
  const apply = useDatos((x) => x.apply);
  const { snapshot } = useFotoEnVivo();
  const ir360 = snapshot?.idp.ir360 ?? null;
  const areas = snapshot?.idp.wheel ?? [];
  const sig = siguienteDiagnostico(d.answeredAt);
  const contestar = (k: (typeof AREAS_RUEDA)[number]["k"], i: number, v: number | null) =>
    apply(d.answeredAt ? setEnLista(`diag.wheel.${k}`, i, v) : encadenar(setEnLista(`diag.wheel.${k}`, i, v), setDiagAnsweredAt(hoyISO())));
  return (
    <SeccionLayout id="rueda" intro={<><b className="text-tinta">Cómo estás hoy, no cómo lo tienes diseñado.</b> Son {TOTAL_RUEDA} preguntas del 1 al 10. Las vuelves a contestar cada trimestre para ver cómo te mueves.</>}>
      <CandadoSensibles>
      <p className="rounded-md bg-fondo p-3 text-xs text-tinta-suave"><b className="text-tinta">1</b> = muy bajo · <b className="text-tinta">10</b> = muy alto. La escala es distinta a la del IDP a propósito: el IDP mide madurez de diseño; esto mide estado.</p>
      {AREAS_RUEDA.map((a) => {
        const area = areas.find((w) => w.key === a.k);
        return (
          <Bloque key={a.k} titulo={a.titulo} ayuda={area?.legacy ? "Tu Excel de WealthX trajo esta área como un solo número; si contestas las preguntas, se usan esas." : undefined}>
            <ol className="flex flex-col gap-5">{a.preguntas.map((q, i) => (
              <li key={i} className="flex flex-col gap-2"><span className="text-sm font-medium">{q}</span><Escala etiqueta={q} max={10} valor={d.wheel[a.k][i]} onChange={(v) => contestar(a.k, i, v)} /></li>
            ))}</ol>
            {area?.value !== null && area?.value !== undefined && <p className="mt-4 text-sm text-tinta-suave">Promedio de {a.titulo}: <b className="tabular text-tinta">{area.value.toFixed(1)}</b> de 10</p>}
          </Bloque>
        );
      })}
      {ir360 !== null && (
        <p className="rounded-md border border-borde bg-white p-4 text-sm">Tu IR360: <b className="tabular text-lg">{Math.round(ir360)} / 100</b><br />
          <span className="text-tinta-suave">Tu rueda explica tu IDP: si lo emocional está bajo, es muy probable que los pasos 1 y 2 también lo estén.{d.answeredAt && ` Contestado el ${fechaCorta(d.answeredAt)}`}{sig && ` · el siguiente toca ${sig.vencido ? "ya" : `a partir del ${fechaCorta(sig.fecha)}`}`}.</span>
        </p>
      )}
      </CandadoSensibles>
    </SeccionLayout>
  );
}
